    <div class="notification option_01 noindex" *ngIf="globalNotification && !hasCookieConstentOverlay">
    <div class="container" *ngIf="cookieData$ | async as cookieData">
        <div class="notificationcontent">
            <div class="notificationleft">
                <p class="small marginless">
                    <span [innerText]="cookieData.Copy"></span>
                    <ng-container *ngIf="portalId$ | async as portalId">
                        <a
                            da-link
                            class="notification-link"
                            [routerLink]="'/partner/' + portalId + '/disclaimer' | localize"
                            [innerText]="cookieData.LinkLabel"
                        ></a>
                    </ng-container>
                    <ng-container *ngIf="!(portalId$ | async)">
                        <a
                            da-link
                            class="notification-link"
                            [routerLink]="site !== 'global' ? ('/data-protection' | localize) : '/dataprotection'"
                            [innerText]="cookieData.LinkLabel"
                        ></a>
                    </ng-container>
                </p>
            </div>
            <div class="notificationright">
                <button da-button [icon]="'close'" (click)="hideGlobalNotification()"></button>
            </div>
        </div>
    </div>
</div>
